import { FONT_WEIGHT, TEXT_ALIGN } from '../../foundations/typography';
import { TextVariantType } from '../variants';
export const commonStyles = (FOUNDATIONS, FONT) => ({
    title: {
        margin_bottom: FOUNDATIONS.spacing_150,
    },
    rowContainer: {
        row_gap: FOUNDATIONS.spacing_50,
        column_gap: FOUNDATIONS.spacing_150,
    },
    radioButton: {
        border_radius: FOUNDATIONS.radius_comp_forms_radiobutton_radiussize,
        height: FOUNDATIONS.size_300,
        width: FOUNDATIONS.size_300,
        background_color: 'transparent',
        border_width: FOUNDATIONS.border_50,
        border_style: 'solid',
        border_color: FOUNDATIONS.color_neutral_border_150,
    },
    label: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        font_weight: FONT_WEIGHT.font_regular,
        color: FOUNDATIONS.color_neutral_font_50,
    },
    icon: {
        height: FOUNDATIONS.size_150,
        width: FOUNDATIONS.size_150,
        border_radius: FOUNDATIONS.radius_1000,
    },
});
export const disabledCommonStyles = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT),
    radioButton: {
        ...commonStyles(FOUNDATIONS, FONT).radioButton,
        cursor: 'not-allowed',
        background_color: FOUNDATIONS.color_accent_disabled_bg_100,
        border_color: FOUNDATIONS.color_accent_disabled_border_100,
    },
});
export const errorCommonStyles = (FOUNDATIONS, FONT) => ({
    ...commonStyles(FOUNDATIONS, FONT),
    radioButton: {
        ...commonStyles(FOUNDATIONS, FONT).radioButton,
        border_color: FOUNDATIONS.color_feedback_error_border_50,
    },
    errorMessage: {
        font_variant: TextVariantType.FONT_PARAGRAPH_350,
        font_weight: FONT_WEIGHT.font_regular,
        text_align: TEXT_ALIGN.left,
        color: FOUNDATIONS.color_feedback_error_font_50,
    },
    errorMessageIconContainer: {
        margin_right: FOUNDATIONS.spacing_100,
    },
    errorMessageIcon: {
        width: FOUNDATIONS.size_250,
        height: FOUNDATIONS.size_250,
        color: FOUNDATIONS.color_feedback_error_icon_50,
    },
});
//# sourceMappingURL=commonStyles.js.map